import { render, staticRenderFns } from "./AddAddressModal.vue?vue&type=template&id=3a59eaa8&scoped=true&"
import script from "./AddAddressModal.vue?vue&type=script&lang=js&"
export * from "./AddAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59eaa8",
  null
  
)

export default component.exports